import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConductRequestBodyModel } from '../../models/conducts-request-body.model';
import { LogDeviceModel } from '../../models/log-device.model';
import { StringFormatPipe } from '../../pipe/string.format.pipe';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { PlatformEndpointService } from '../communicator/endpoint/endpoint.service';
import { PlatformCommunicatorAuthService } from '../communicator/platform-communicator/platform-communicator.auth.service';
import { PlatformCommunicatorService } from '../communicator/platform-communicator/platform-communicator-onboarding.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { CHANNEL } from '../../constants/channel.constants';
import { CryptoVaultService } from '../external/crypto-vault/crypto-vault.service';
import * as i0 from "@angular/core";
import * as i1 from "../communicator/endpoint/endpoint.service";
import * as i2 from "../communicator/platform-communicator/platform-communicator-onboarding.service";
import * as i3 from "../communicator/channel-communicator/channel-communicator.service";
import * as i4 from "../../pipe/string.format.pipe";
import * as i5 from "../communicator/platform-communicator/platform-communicator.auth.service";
import * as i6 from "../parameters/parameters.service";
import * as i7 from "../helpers/validation-helper.service";
import * as i8 from "@angular/common/http";
import * as i9 from "../external/crypto-vault/crypto-vault.service";
import * as i10 from "../abre-cuentas/abre-cuentas.service";
/* para esos service agregar el crypto en true cuando se realice ajuste en cryptovault
  URLS.SEND_BACK_DOCUMENT_INFO ||
   URLS.FRONT_DOCUMENT_INFO ||
   URLS.FINGER_PRINTS_INFO ||
   URLS.AGREEMENTS_OFFERS) {
   headers = headers.append('use_cripto', 'false');
}*/
var headerCrypto = new HttpHeaders({
    use_cripto: 'true',
});
/**
 * Obtener el valor de una dependencia, en este caso, ésta clase es visible para toda la app
 *
 * *Obtain the valua of a dependency, in this case, this class is visible for the entire app*
 */
var RequestService = /** @class */ (function () {
    /**
     * Summary Constructor of the component.
     *
     * @param {PlatformEndpointService}     endpointService      Injectable endpointService service.
     * @param {PlatformCommunicatorService} communicatorService  Injectable communicatorService service.
     * @param {StringFormatPipe}            stringFormat         Injectable stringFormat pipe.
     */
    function RequestService(endpointService, communicatorService, channelCommunicatorService, stringFormat, authService, parametersService, validationHelperService, httpClient, cipherService, abreCuentasService) {
        this.endpointService = endpointService;
        this.communicatorService = communicatorService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.stringFormat = stringFormat;
        this.authService = authService;
        this.parametersService = parametersService;
        this.validationHelperService = validationHelperService;
        this.httpClient = httpClient;
        this.cipherService = cipherService;
        this.abreCuentasService = abreCuentasService;
    }
    /**
     * Obtiene la calificación de acuerdo a los parámetros enviados por el usuario
     *
     * *Gets the score depending on users parameteres that were sent*
     *
     * @param config
     * @param bodyFields
     * @param csid
     * @param activity
     * @param brand
     * @param ppid
     * @param solution
     * @param deviceModel
     * @param ip
     * @param applicationID
     * @returns {Promise}
     * @method get
     */
    RequestService.prototype.getScore = function (config, bodyFields, csid, activity, brand, ppid, solution, deviceModel, ip, applicationID, yearOfBrith) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, headers, options, appendSessionHeader;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                data = new ConductRequestBodyModel(bodyFields, config.action, activity, brand, ppid, solution, deviceModel, ip);
                if (applicationID !== undefined) {
                    data.applicationId = applicationID;
                }
                if (yearOfBrith &&
                    activity === bodyFields.activity_type_pre &&
                    bodyFields.application_type === 'WEB') {
                    data.yearOfBirth = yearOfBrith;
                    data.activityName = bodyFields.activity_name;
                }
                headers = new HttpHeaders({
                    application: bodyFields.application,
                    session_id: csid,
                });
                options = {
                    url: this.endpointService.URLS.BIOCATCH_UPDATE,
                    method: 'post',
                    body: {
                        data: data,
                    },
                    headers: headers,
                };
                appendSessionHeader = csid === 'null' ? true : false;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false, true, appendSessionHeader)
                            .then(function (response) { return resolve(response.body.data); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     *
     * Envía los parámetros para revisar la calificación del usuario
     *
     * *Sends parameters to check user score*
     *
     * @param any body
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.checkScore = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.BIOCATCH_CHECK_SCORE,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Guarda la información del dispositivo en la bítacora
     *
     * *Save device information in Bitacora*
     *
     * @param {LogDeviceModel} device
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.saveDataInBitacora = function (device, isCSID, crypto) {
        if (isCSID === void 0) { isCSID = false; }
        if (crypto === void 0) { crypto = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (isCSID) {
                    device.device.device_id = 'csid';
                }
                headers = new HttpHeaders({
                    'token-client-id': '39540626_1',
                    'session_id': this.authService.getSessionId(),
                });
                options = {
                    url: this.endpointService.URLS.TERMS_CONDITIONS,
                    method: 'post',
                    body: device,
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, crypto)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Valida las reglas
     *
     * *Rules Validation*TERMS_CONDITIONS
     *
     * @param {any} rules
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.validateRules = function (rules) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.VALIDATE_RULES,
                    method: 'post',
                    body: rules,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Asigna el tipo de producto
     *
     * *Assign product type*
     *
     * @param {string} product
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.assignProductType = function (product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.ASSIGN_PRODUCT_TYPE,
                    method: 'patch',
                    body: {
                        product_type: product,
                    },
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Asigna el tipo de producto
     *
     * *Assign product type*
     *
     * @param {string} product
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.offersSelectAgreement = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.OFFERS_SELECT_AGREEMENT,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Retorna los acuerdos de cada oferta
     *
     * *Gets Offer's Agreements*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getAgreementsOffers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.AGREEMENTS_OFFERS,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Retorna los datos ingresados en el simulador
     *
     * *Gets Simulator Data*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getSimulationData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_SIMULATION,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Retorna los datos de PCO
     *
     * *Gets Channel Notification Data*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getChannelNotification = function (solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, document_number, document_type, headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                url = this.endpointService.URLS.GET_CHANNEL_NOTIFICATION;
                document_number = this.abreCuentasService.getDocumentInfo().document_number;
                document_type = this.abreCuentasService.getDocumentInfo().document_type;
                headers = new HttpHeaders({
                    'token-client-id': document_number + '_' + document_type,
                });
                options = {
                    url: this.stringFormat.transform(url, [solicitationId]),
                    method: 'get',
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Retorna los datos de PCO para un cliente (Solicitudes)
     *
     * *Gets Channel Notification Data*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getChannelNotificationClient = function (token_client_id, consulta) {
        if (consulta === void 0) { consulta = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                url = this.endpointService.URLS.GET_CHANNEL_NOTIFICATION_2;
                if (!consulta) {
                    headers = token_client_id
                        ? new HttpHeaders({
                            'token-client-id': token_client_id,
                        })
                        : undefined;
                    console.log(token_client_id, 'token_client_id');
                }
                options = {
                    url: url,
                    method: 'get',
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    RequestService.prototype.formatDocumentInfo = function (documentInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var document_type, card_number, document_number, primary_lastname, second_lastname, firstname, middlename, sex, birthdate;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log(documentInfo);
                        return [4 /*yield*/, this.cipherService.refreshKeyCrypto()];
                    case 1:
                        _a.sent();
                        document_type = documentInfo.document_type === '' ? null : documentInfo.document_type;
                        card_number = documentInfo.card_number === '' ? null : documentInfo.card_number;
                        document_number = documentInfo.document_number === '' ? null : documentInfo.document_number;
                        primary_lastname = documentInfo.primary_lastname === '' ? null : documentInfo.primary_lastname;
                        second_lastname = documentInfo.second_lastname === '' ? null : documentInfo.second_lastname;
                        firstname = documentInfo.firstname === '' ? null : documentInfo.firstname;
                        middlename = documentInfo.middlename === '' ? null : documentInfo.middlename;
                        sex = documentInfo.sex === '' ? null : documentInfo.sex;
                        birthdate = documentInfo.birthdate === '' ? null : documentInfo.birthdate;
                        if (!document_type) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(document_type)];
                    case 2:
                        document_type = _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!card_number) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(card_number)];
                    case 4:
                        card_number = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!document_number) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(document_number)];
                    case 6:
                        document_number = _a.sent();
                        _a.label = 7;
                    case 7:
                        if (!primary_lastname) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(primary_lastname)];
                    case 8:
                        primary_lastname = _a.sent();
                        _a.label = 9;
                    case 9:
                        if (!(second_lastname != null)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(second_lastname)];
                    case 10:
                        second_lastname = _a.sent();
                        _a.label = 11;
                    case 11:
                        if (!firstname) return [3 /*break*/, 13];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(firstname)];
                    case 12:
                        firstname = _a.sent();
                        _a.label = 13;
                    case 13:
                        if (!(middlename != null)) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(middlename)];
                    case 14:
                        middlename = _a.sent();
                        _a.label = 15;
                    case 15:
                        if (!sex) return [3 /*break*/, 17];
                        return [4 /*yield*/, this.cipherService.encrypt(sex)];
                    case 16:
                        sex = _a.sent();
                        _a.label = 17;
                    case 17:
                        if (!birthdate) return [3 /*break*/, 19];
                        return [4 /*yield*/, this.cipherService
                                .encrypt(birthdate)];
                    case 18:
                        birthdate = _a.sent();
                        _a.label = 19;
                    case 19: 
                    // eslint-disable-line nombre-del-mensaje
                    return [2 /*return*/, tslib_1.__assign({}, documentInfo, { birthdate: birthdate,
                            document_type: document_type,
                            card_number: card_number,
                            document_number: document_number,
                            primary_lastname: primary_lastname,
                            second_lastname: second_lastname,
                            firstname: firstname,
                            middlename: middlename,
                            sex: sex })];
                }
            });
        });
    };
    /**
     * Envía la información de la parte de atrás del documento
     *
     * *Sends back document info*
     *
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendBackDocumentInfo = function (documentInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var body, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.formatDocumentInfo(documentInfo)];
                    case 1:
                        body = _a.sent();
                        options = {
                            url: this.endpointService.URLS.SEND_BACK_DOCUMENT_INFO,
                            method: 'post',
                            body: body,
                            headerCrypto: headerCrypto,
                        };
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                _this.communicatorService
                                    .request(options)
                                    .then(function (response) {
                                    resolve(response);
                                })
                                    .catch(function (err) { return (err.status === 422 ? resolve(err) : reject(err)); });
                            })];
                }
            });
        });
    };
    /**
     * Envía la información de la parte frontal del documento
     *
     * *Sends front document info*
     *
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendFrontDocumentInfo = function (documentPhoto, facePhoto) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.FRONT_DOCUMENT_INFO,
                    method: 'post',
                    body: {
                        front_document_picture: documentPhoto,
                        face_picture: facePhoto,
                    },
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la información de las huellas
     *
     * *Sends finger prints information*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendFingerPrintsInfo = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.FINGER_PRINTS_INFO,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Obtiene la información de un cliente
     *
     * *Gets client information*
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getClientInformation = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.CLIENT_INFORMATION,
                    method: 'post',
                    body: body,
                };
                console.warn('consumiendo getClientInformation----');
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) {
                            console.log('Rta exitosa: ', response);
                            resolve(response);
                        })
                            .catch(function (err) {
                            console.warn('Error: ', err);
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Obtiene la información de un cliente
     *
     * *Gets client information*
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getCardCategoryByBrand = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                headers = new HttpHeaders({
                    username: 'FP446215',
                });
                options = {
                    url: this.endpointService.URLS.GET_CARD_CATEGORY_BY_BRAND,
                    method: 'post',
                    body: body,
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Obtiene la información de un cliente
     *
     * *Gets client information*
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getResultPco = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_RESULT_PCO,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            // .then(response => resolve(response.body))
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Obtiene la publicacion de firma
     *
     * **
     * @method getc
     * @returns {Promise}
     */
    RequestService.prototype.getOTP = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_OTP,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return (err.status === 422 ? resolve(err) : reject(err)); });
                    })];
            });
        });
    };
    /**
     * Valida el codigo otp
     *
     * **
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.validateOTP = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.VALIDATE_OTP,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return (err.status === 422 ? resolve(err) : reject(err)); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación
     *
     * *Sends prospect occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.getSessionId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_SESSION_ID,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación
     *
     * *Sends prospect occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectOccupation = function (body, parms) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_OCCUPATION,
                    method: 'post',
                    body: body,
                    params: parms,
                };
                console.log('body ------>', body);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación independiente
     *
     * *Sends prospect independent occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectIndependentOccupation = function (occupation) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_INDEPENDENT_OCCUPATION,
                    method: 'post',
                    body: occupation,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            // .then(response => resolve(response.body))
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación independiente
     *
     * *Sends prospect independent occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendPostTermsAndConditions = function (devicePrint) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_INDEPENDENT_OCCUPATION,
                    method: 'post',
                    devicePrint: devicePrint,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación independiente
     *
     * *Sends prospect independent occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectIncomeForm = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_INCOME_FORM,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación independiente
     *
     * *Sends prospect independent occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectOperationCurrency = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_OPERATION_CURRENCY,
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ocupación independiente
     *
     * *Sends prospect independent occupation*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectForeignCurrencyProducts = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_FOREIGN_PRODUCT_DETAIL,
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la ciudad de nacimiento
     *
     * *Sends prospect birthplace*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectBirthplace = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_BIRTHPLACE,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Crea un caso de información de dirección
     *
     * *Creates a address information case*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createCaseAddress = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isPassive, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isPassive = this.validationHelperService.isPassiveProduct();
                options = {
                    url: this.stringFormat.transform(isPassive
                        ? this.endpointService.URLS.PROSPECT_CREATE_CASE_ADDRESS
                        : this.endpointService.URLS.PROSPECT_CREATE_CASE_ADDRESS_ACTIVO, [solicitationId]),
                    method: isPassive ? 'patch' : 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Crea un caso de información de contacto
     *
     * *Creates a contact information case*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createCaseContactInfo = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isPassive, url, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isPassive = this.validationHelperService.isPassiveProduct();
                url = isPassive
                    ? this.endpointService.URLS.CONTACT_INFO
                    : this.endpointService.URLS.CONTACT_INFO_ACTIVOS;
                options = {
                    url: this.stringFormat.transform(url, [solicitationId]),
                    method: isPassive ? 'patch' : 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_contact');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Crea un nuevo cliente.
     *
     * *Creates a new client*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createClient = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isPassive, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isPassive = this.validationHelperService.isPassiveProduct();
                options = {
                    url: this.stringFormat.transform(isPassive
                        ? this.endpointService.URLS.CREATE_CLIENT
                        : this.endpointService.URLS.CREATE_CLIENT_ACTIVOS, [solicitationId]),
                    method: isPassive ? 'patch' : 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_clients');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Registra un nuevo producto al cliente.
     *
     * *Register a new product for the customer*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createProduct = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.CREATE_PRODUCT, [solicitationId]),
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Ejecuta la solicitud del cliente cliente.
     *
     * *Excecute de customer request*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.performSolicitation = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.CREATE_CASE_PERFORM_SOLICITATION, [solicitationId]),
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Ejecuta la solicitud del cliente cliente.
     *
     * *Excecute de customer request*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.getCase = function (solicitationId, productCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.GET_CASE_SOLICITATION_INFO, [solicitationId]),
                    method: 'get',
                    params: {
                        productType: productCode,
                    },
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Envia la informacion de contacto de un prospecto
     *
     * *Sends prospect contact*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectContact = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_CONTACT,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función guardar información de la ciudad y dirección de la oficina
     *
     * *Function that saves office address*
     *
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectOfficeAddress = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_OFFICE_ADDRESS,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función guardar información financiera
     *
     * *Function that saves financial info*
     *
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.sendProspectFinancial = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.PROSPECT_FINANCIAL,
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Crea un caso de solicitud
     *
     * *Creates a solicitation case*
     * @method post
     * @returns {Promise}
     */
    // Servicio en mock
    RequestService.prototype.createCaseSolicitationId = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_CREATE_CASE_SOLICITATION_ID,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response.body.solicitation_id);
                        }, function (err) { return reject(err); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Crea un caso de información de contacto
     *
     * *Creates a contact information case*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createCaseFinancials = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isPassive, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isPassive = this.validationHelperService.isPassiveProduct();
                options = {
                    url: this.stringFormat.transform(isPassive
                        ? this.endpointService.URLS.PROSPECT_CREATE_CASE_FINANCIAL
                        : this.endpointService.URLS.PROSPECT_CREATE_CASE_FINANCIAL_ACTIVOS, [solicitationId]),
                    method: isPassive ? 'patch' : 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response.body);
                        })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_financial');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Crea un caso para actualizar la configuración de la cuenta
     *
     * *Update case account config case*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.updateCaseAccountConfig = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.UPDATE_CASE_ACCOUNT_CONFIG,
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Crea un caso de información de contacto
     *
     * *Creates a contact information case*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.foreignOperationsCase = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isPassive, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                isPassive = this.validationHelperService.isPassiveProduct();
                options = {
                    url: this.stringFormat.transform(isPassive
                        ? this.endpointService.URLS.PROSPECT_CREATE_CASE_FOREIGN_OPERATION
                        : this.endpointService.URLS.PROSPECT_CREATE_CASE_FOREIGN_ACTIVOS, [solicitationId]),
                    method: isPassive ? 'patch' : 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_operations');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de configuración
     *
     * *Async Function that sends config*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.offersConfig = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.OFFERS_CONFIG,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para enviar la información de beneficios
     *
     * *Async Function that get benefits*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.offersGetBenefits = function (agreementCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.OFFERS_GET_BENEFITS, [agreementCode]),
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para crear el caso de solicitud
     *
     * *Async Function that create case perform*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.createCasePerformSolicitation = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.CREATE_CASE_PERFORM_SOLICITATION, [solicitationId]),
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función asíncrona para obtener información del caso
     *
     * *Async Function that get case info*
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getCaseSolicitationInfo = function (solicitationId, productCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                headers = new HttpHeaders({
                    channel_id: '141',
                });
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.GET_CASE_SOLICITATION_INFO, [solicitationId]),
                    method: 'get',
                    params: {
                        productType: productCode,
                    },
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true)
                            // .then(response => resolve(response.body))
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * envia informacion de direcciones
     *
     * *send address informatino*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.getProspectAddress = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.CREATE_CLIENT, [solicitationId]),
                    method: 'patch',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_address');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    RequestService.prototype.getRatesFromServer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.GET_RATES,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Trae los productos del Aprobado En Firme que se cargan a través de vitrinas
     * @param {String} offer_id - Id de la oferta que se mostró en la vitrina
     * si este parametro no es enviado traera todas las ofertas del usuario actual
     * @returns {[any]} - Objeto con los productos de la vitrina
     */
    RequestService.prototype.getOffersFromServer = function (offer_id) {
        if (offer_id === void 0) { offer_id = '0'; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                console.warn('Iniciando consumo de getOffersFromServer >>>> ', offer_id);
                options = {
                    // url: this.endpointService.URLS.GET_OFFERS,
                    url: this.stringFormat.transform(this.endpointService.URLS.GET_OFFERS, [
                        offer_id,
                    ]),
                    method: 'get',
                };
                console.warn('URL  a consumir >>> ', options);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                        /* resolve(GET_OFFERS); */
                    })];
            });
        });
    };
    /**
     * Actualiza el estado de la oferta que se visualiza en el home de los canales
     * y que es de Aprobados En Firme
     * @param {String} offer_id - Id de la oferta a actualizar
     * @param {number} status_id - Estado a asignar a la oferta de la vitrina
     * @returns {any} - Respuesta del consumo del servicio back
     */
    RequestService.prototype.updateOffer = function (status, offer_list, product_list) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var offer_list2, product_list2, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                offer_list2 = offer_list.map(function (offer) {
                    return { offer_id: String(offer.offerId) };
                });
                product_list2 = product_list
                    ? product_list.map(function (product) {
                        return { product_type: product.product_code };
                    })
                    : undefined;
                options = {
                    url: this.endpointService.URLS.UPDATE_OFFERS,
                    method: 'patch',
                    body: {
                        data: {
                            status: String(status),
                            offer_list: offer_list2,
                            product_list: product_list2,
                            token_id: '',
                        },
                    },
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                        /* resolve('Actualizado'); */
                    })];
            });
        });
    };
    RequestService.prototype.setRates = function (ratesList) {
        this.ratesList = ratesList;
    };
    RequestService.prototype.getRates = function () {
        if (this.ratesList) {
            return this.ratesList;
        }
        return null;
    };
    /**
     * trae los productos del cliente que puede asociar con onboarding
     * envia informacion de direcciones
     *
     * *send address informatino*
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.clientProduct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, _a, document_number, document_type, options;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                headers = new HttpHeaders({
                    operation_target: this.parametersService.getParameter('headers').operation_target,
                });
                if (this.channelCommunicatorService.getChannelId() === CHANNEL.PORTALO.CODE) {
                    _a = this.abreCuentasService.getDocumentInfo(), document_number = _a.document_number, document_type = _a.document_type;
                    headers = headers.append('token-client-id', document_number + "_" + document_type);
                }
                options = {
                    url: this.endpointService.URLS.CLIENT_PRODUCT,
                    method: 'get',
                };
                options.headers = headers;
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    RequestService.prototype.getRestrictiveList = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.RESTRICTIVE_LIST,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options) // Habilidar a true crypto
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Función de llamado de servicio de update de biocatch
     *
     * *Function that calls biocatch update service*
     *
     * @param bodyFields
     * @param csid
     * @param ppid
     * @param failedAtempts
     * @param jobDescription
     * @param yearOfBirth
     * @param ageRange
     * @param solicitationType
     * @param deviceModel
     * @param ip
     * @param maritalStatus
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.biocatchUpdate = function (bodyFields, csid, ppid, failedAtempts, jobDescription, yearOfBirth, ageRange, solicitationType, deviceModel, ip, maritalStatus) {
        var _this = this;
        var model = new ConductRequestBodyModel(bodyFields, bodyFields.operation_target, solicitationType, bodyFields.brand, ppid, bodyFields.method_description, deviceModel, ip);
        model.jobDescription = jobDescription;
        model.numOfFailedAuth = failedAtempts;
        model.yob = ageRange;
        model.yearOfBirth = yearOfBirth;
        model.authMethodUsed = bodyFields.auth_method;
        if (maritalStatus) {
            model.maritalStatus = maritalStatus;
        }
        var body = {
            data: model,
        };
        var headers = new HttpHeaders({
            application: bodyFields.application,
            session_id: csid,
        });
        var options = {
            url: this.endpointService.URLS.BIOCATCH_UPDATE,
            method: 'post',
            body: body,
            headers: headers,
        };
        var appendSessionHeader = csid === 'null' ? true : false;
        return new Promise(function (resolve, reject) {
            _this.communicatorService
                .request(options, false, true, appendSessionHeader)
                .then(function (response) { return resolve(response); })
                .catch(function (err) { return reject(err); });
        });
    };
    /**
     * Funciónque llama el servicio de ppid
     *
     * *Function that calls ppid service*
     *
     * @param bodyFields
     * @returns {Promise}
     * @method get
     */
    RequestService.prototype.getPpid = function (bodyFields) {
        var _this = this;
        var headers = new HttpHeaders({
            application: bodyFields.application,
        });
        var options = {
            url: this.endpointService.URLS.GET_PPID,
            method: 'get',
        };
        return new Promise(function (resolve, reject) {
            _this.communicatorService
                .request(options, false, true)
                .then(function (response) { return resolve(response); })
                .catch(function (err) { return reject(err); });
        });
    };
    /**
     * perform para llamar los servicios de terceras fuentes desde bizagi
     *
     * *call incomes since bizagi*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.performIncomes = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.PERFORM_INCOMES, [solicitationId]),
                    method: 'post',
                    body: body,
                };
                console.log('--------------performIncomes------------');
                console.log(options);
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response);
                        })
                            .catch(function (err) {
                            console.log('Reject >>>> ', err);
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_incoment');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Llamar los servicios de PCO desde bizagi
     *
     * *call PCO since bizagi*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.performPco = function (body, solicitationId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.PERFORM_PCO, [
                        solicitationId,
                    ]),
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, true) // Habilidar a true crypto
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) {
                            if (_this.errCrypto(err.message)) {
                                _this.saveBitacora('ups_error_700_crypto_pco');
                            }
                            reject(err);
                        });
                    })];
            });
        });
    };
    /**
     * Retorna los acuerdos de cada oferta
     *
     * *Gets Loan's Agreements*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getAgreementsLoan = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.AGREEMENTS_LOAN,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Retorna los acuerdos de cada oferta
     *
     * *Gets Loan's Agreements*
     *
     * @method get
     * @returns {Promise}
     */
    RequestService.prototype.getAgreementsLoanDetail = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.AGREEMENTS_DETAIL, [id]),
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /*
     * Obtiene la solicitud utilizando el número de solicitud
     * @param code
     * @returns
     */
    RequestService.prototype.getRequestByNumber = function (code) {
        return new Promise(function (resolve, reject) {
            if (!code) {
                reject();
                return;
            }
            resolve({
                user: {
                    name: 'x',
                    document: '123',
                },
                data: [
                    {
                        name: 'primera',
                        date: '12-10-2021',
                    },
                ],
            });
        });
        // const options = {
        //   url: this.stringFormat.transform(this.endpointService.URLS.REQUEST_URL, [code]),
        //   method: 'get',
        // };
        // return new Promise((resolve, reject) => {
        //   this.communicatorService
        //     .request(options, false) // Habilidar a true crypto
        //     .then(response => resolve(response))
        //     .catch(err => reject(err));
        // });
    };
    /**
     * Llamar servicio carga de documento (Prefirm)
     *
     * *call load document service (Prefirm)
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.loadDocument = function (body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.LOAD_FILE,
                    method: 'post',
                    body: body,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Llamar servicio de suficiencia documental
     *
     * *call documentary sufficency service*
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.documentarySufficiency = function (principalActivityId, operationTarget) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                principalActivityId = '36';
                operationTarget = '0001';
                options = {
                    url: this.endpointService.URLS.DOCUMENTARY_SUFFICIENCY +
                        '?' +
                        'operation_target=' +
                        operationTarget +
                        '&principal_activity_id=' +
                        principalActivityId,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    // async sendBackDocumentInfo2(documentInfo: DocumentModel): Promise<any> {
    //   const headers = new HttpHeaders({
    //     'channel-id': '131-2',
    //   });
    //   const options = {
    //     url: this.endpointService.URLS.SEND_BACK_DOCUMENT_INFO,
    //     method: 'post',
    //     body: documentInfo,
    //     headers,
    //   };
    //   return new Promise((resolve, reject) => {
    //     this.communicatorService
    //       .request(options, true)
    //       .then(response => {
    //         resolve(response);
    //       })
    //       .catch(err => err.status === 422 ? resolve(err) : reject(err));
    //   });
    // }
    /**
     * Verifica por documento si se encuentra en la base de relacionados
     *
     * *Checks by document if the identification is un related base*
     *
     * @method post
     * @returns {Promise}
     */
    RequestService.prototype.checkIfIsRelated = function (documentId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.SEND_BACK_DOCUMENT_INFO,
                    method: 'post',
                    body: documentId,
                    headerCrypto: headerCrypto,
                };
                // return new Promise((resolve, reject) => {
                //   this.communicatorService
                //     .request(options)
                //     .then(response => {
                //       resolve(response);
                //     })
                //     .catch(err => err.status === 422 ? resolve(err) : reject(err));
                // });
                ///// Se emula en una promesa el resolve true o false (Está o no está en base relacionados)
                return [2 /*return*/, new Promise(function (resolve) {
                        resolve({
                            status: 200,
                            body: {
                                related: false,
                            },
                        });
                    })];
            });
        });
    };
    RequestService.prototype.cityBranches = function (cityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.stringFormat.transform(this.endpointService.URLS.CITY_BRANCHES, [cityId]),
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) { return resolve(response); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    RequestService.prototype.districtBrances = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.BRANCHES_DISTRICT,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) {
                            resolve(response); // console.log(response);
                        })
                            .catch(function (err) {
                            reject(err); // console.log(err);
                        });
                    })];
            });
        });
    };
    /**
     * Valida las tasas de aliados
     *
     * *Tasas Validation*INFO_VALIDATION
     *
     * @param {any} rules
     * @returns {Promise}
     * @method post
     */
    RequestService.prototype.validateInfo = function (codeallies) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url, headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                url = this.endpointService.URLS.CONFIG_RATES_ALLY;
                headers = new HttpHeaders({
                    use_cripto: 'false',
                });
                options = {
                    url: this.stringFormat.transform(url, [codeallies]),
                    method: 'get',
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    /**
     * Trae la informacion de aliados
     *
     *
     * @param {any} rules
     * @returns {Promise}
     * @method get
     */
    RequestService.prototype.documentsAllies = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                options = {
                    url: this.endpointService.URLS.DOCUMENTS_ALLIES,
                    method: 'get',
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false)
                            .then(function (response) { return resolve(response.body); })
                            .catch(function (err) { return reject(err); });
                    })];
            });
        });
    };
    RequestService.prototype.saveBitacora = function (eventName) {
        var devicePrint = new LogDeviceModel();
        var product_name = this.abreCuentasService.getproductSelected()
            ? this.abreCuentasService.getproductSelected().product_code
            : '';
        devicePrint.device = this.abreCuentasService.getDeviceInfo();
        // const ipBiocatch = this.bioCatchService.getCurrentScoreIp();
        devicePrint.device.event_name = eventName;
        // devicePrint.device.ip = ipBiocatch;
        devicePrint.terms_type = eventName;
        this.saveDataInBitacora(devicePrint);
    };
    RequestService.prototype.errCrypto = function (err) {
        var code = false;
        switch (err) {
            case '601':
                code = true;
                break;
            case 'Cannot read properties of undefined (reading "message")':
                code = true;
                break;
        }
        return code;
    };
    RequestService.prototype.getSettingsConfig = function (key) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                headers = new HttpHeaders({
                    keyMongo: key,
                });
                options = {
                    url: this.endpointService.URLS.SETTINGS_CONFIG,
                    method: 'get',
                    headers: headers,
                };
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.communicatorService
                            .request(options, false) // Habilidar a true crypto
                            .then(function (response) {
                            resolve(response.body);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    })];
            });
        });
    };
    RequestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RequestService_Factory() { return new RequestService(i0.ɵɵinject(i1.PlatformEndpointService), i0.ɵɵinject(i2.PlatformCommunicatorService), i0.ɵɵinject(i3.ChannelCommunicatorService), i0.ɵɵinject(i4.StringFormatPipe), i0.ɵɵinject(i5.PlatformCommunicatorAuthService), i0.ɵɵinject(i6.ParametersService), i0.ɵɵinject(i7.ValidationHelperService), i0.ɵɵinject(i8.HttpClient), i0.ɵɵinject(i9.CryptoVaultService), i0.ɵɵinject(i10.AbreCuentasService)); }, token: RequestService, providedIn: "root" });
    return RequestService;
}());
export { RequestService };
